var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 28.3h-8.1L26.4 9.8c-.1-.5-.5-.9-1-.8-.5.1-.9.5-.8 1l1.9 14.3h-1l-.1-1.6c-.1-.5-.5-.8-1-.8h-2.7L17 7.7c-.1-.4-.5-.7-.8-.7H6.6c-.5 0-1 .4-1 1v12.9H4c-.5 0-1 .4-1 1v7.4c0 .5.4 1 1 1h1.1c.4 1.7 2 3 3.8 3 1.9 0 3.3-1.3 3.8-3H16c.4 1.7 2 3 3.8 3 1.9 0 3.3-1.3 3.8-3h1.6c.6 0 1-.5 1-1.1l-.4-2.7h1l.4 3c.1.5.5.8 1 .8h9c.5 0 1-.4 1-1-.2-.7-.6-1-1.2-1zm-19.2.9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm1.9-3.9c-1.9 0-3.3 1.3-3.8 3h-3.3c-.4-1.7-2-3-3.8-3-1.9 0-3.3 1.3-3.8 3h-.1v-5.4h1.7c.5 0 1-.4 1-1v-1.6h4.8l.8 2.9c.1.4.5.7.9.7h9.1l.6 4.3h-.4c-.3-1.7-1.8-2.9-3.7-2.9zM6.9 29.2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm.7-20.3h7.7L19.5 22H15l-.8-2.8c-.1-.4-.5-.7-.9-.7H7.6V8.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 17.9h-7.2c-.5 0-1 .4-1 1v7.2c0 .5.4 1 1 1H37c.5 0 1-.4 1-1v-7.2c-.1-.5-.4-1-1-1zm-1 7.2h-5.3v-5.3h1.6v.6c0 .5.4 1 1 1 .5 0 1-.4 1-1v-.6h1.6l.1 5.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.b25b15cb.svg";
export { ForwardRef as ReactComponent };